// extracted by mini-css-extract-plugin
export var button = "ProductResult-module--button--IAYwI";
export var erase = "ProductResult-module--erase--8k2ij";
export var image = "ProductResult-module--image--hV8jj";
export var imageWrapper = "ProductResult-module--imageWrapper--HEDq4";
export var name = "ProductResult-module--name--v64fh";
export var price = "ProductResult-module--price--1cqj5";
export var sku = "ProductResult-module--sku--1DqCL";
export var tax = "ProductResult-module--tax--psMa6";
export var wrapper = "ProductResult-module--wrapper--VXneg";